module.exports = __webpack_public_path__ + "img/section_title1.82680059.png";